import { Button } from '@mui/material';

import Header from '../../components/Shared/Header';

import styles from './styles.module.scss';

const Home = () => {
  const images = [
    {
      name: 'christ',
      alt: 'Portrait of Jesus Christ',
    },
    {
      name: 'family',
      alt: 'A family studying the scriptures',
    },
    {
      name: 'nephites',
      alt: 'Jesus Christ visiting the Nephites in Ancient America',
    },
    {
      name: 'temple',
      alt: 'Payson, Utah Temple',
    },
  ];

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>
        Welcome to the <div className={styles.wardName}>Summit Creek Ward</div>
      </h1>

      <h3 className={styles.subtitle}>Santaquin, Utah</h3>

      <div className={styles.images}>
        {images.map((img, index) => {
          return (
            <img
              src={`/images/${img.name}.png`}
              alt={img.alt}
              key={index}
              className={`${styles.image} ${styles[img.name]}`}
            />
          );
        })}
      </div>

      {/* <TithingDeclaration /> */}

      <div className={styles.spiritualThought}>
        <Header
          title='Spiritual Thought'
          direction='row'
          type='section'
          underlined
        />

        <div className={styles.thought}>
          “So many wonderful things are ahead. In coming days, we will see the
          greatest manifestations of the Savior's power that the world has ever
          seen. Between now and the time He returns 'with power and great
          glory', (Joseph Smith-Matthew 1:36), He will bestow countless
          privileges, blessings, and miracles upon the faithful.”
          <a
            className={styles.reference}
            href='https://www.churchofjesuschrist.org/learn/russell-m-nelson?lang=eng'
            target='_blank'
            rel='noreferrer'
          >
            President Russell M. Nelson
          </a>
        </div>
      </div>
    </div>
  );
};

export default Home;
